export const schedulerDropdown = [
  { label: "Frequency", value: "" },
  { label: "Daily", value: "Daily" },
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
  { label: "Annually", value: "Annually" },
];

export const schedulerTypeDropdown = [
  { label: "Type", value: "" },
  { label: "Transaction", value: "Ecollect" },
  { label: "Ledger", value: "Ledger" },
  // { label: "Settlement", value: "Settlement" },
];

export const schedulerTypeDropdown1 = [
  { label: "Type", value: "" },
  { label: "Transaction", value: "TRANSACTION" },
  { label: "Ledger", value: "INTERCHANGE" },
  { label: "Balance", value: "USER_BALANCE" },
];
export const businessTypeDropdown = [
  { label: "Client Business Type", value: "" },
  { label: "Fintech", value: "Fintech" },
  { label: "Corporates", value: "Corporates" },
  { label: "Hotel-Industry", value: "Hotel-Industry" },
];

export const webHookEventsDropdown = [
  { label: "Activate Events", value: "" },
  { label: "Transaction", value: "Transaction" },
  { label: "Balance", value: "Balance" },
  { label: "Settlement", value: "Settlement" },
];

export const transferTypes = [
  { label: "Transfer Type", value: "" },
  {
    label: "Transfer Type 1",
    value: "Transfer Type 1",
  },
];
export const onboardingTypes = [
  { label: "Onboarding Type", value: "" },
  {
    label: "Aggregator",
    value: "Aggregator",
  },
];
export const ownershipTypes = [
  { label: "Ownership Type", value: "" },
  { label: "PRIVATE", value: "PRIVATE" },
];
export const merchantTypes = [
  { label: "Merchant Type", value: "" },
  { label: "LARGE", value: "LARGE" },
];

export const beneficiaryDropdown = [
  { label: "Select Type", value: "" },
  { label: "NEFT", value: "NEFT" },
  { label: "RTGS", value: "RTGS" },
  { label: "IMPS", value: "IMPS" },
];
